import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-691 (5.1 loading).
export const LoadingScreen = () => (
  <StubScreen id="loading" heading="Ihr Antrag wird geprüft…" />
);
